import styled from "@emotion/styled";

import SelectButton from "metabase/core/components/SelectButton/SelectButton";

export const DashboardPickerButton = styled(SelectButton)`
  min-width: 400px;
`;
